import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-wall",
  "use": "icon-th-wall-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-wall\">\n<path d=\"M28 6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7V25C3 25.2652 3.10536 25.5196 3.29289 25.7071C3.48043 25.8946 3.73478 26 4 26H28C28.2652 26 28.5196 25.8946 28.7071 25.7071C28.8946 25.5196 29 25.2652 29 25V7C29 6.73478 28.8946 6.48043 28.7071 6.29289C28.5196 6.10536 28.2652 6 28 6ZM11 18V14H21V18H11ZM5 18V14H9V18H5ZM23 14H27V18H23V14ZM27 12H17V8H27V12ZM15 8V12H5V8H15ZM5 20H15V24H5V20ZM17 24V20H27V24H17Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-wall.svg
// module id = X0HN
// module chunks = 84